<template>
	<div class='common-wrap'>
		<div class="nav-wrap" v-if="isContract">
			<div class="flex">
				<i class="iconfont icon-home1"></i>
				<router-link class="link" to="/contract/contractView">合同履约</router-link>
				<template>
					<i class="el-icon-arrow-right"></i>
                    <span>合同履约详情</span>
				</template>
			</div>
		</div>
		<div class="common-inner-wrap">
			<div class="image-wrap">
<!--				<img src="../../static/images/creditserver.png" alt="">-->
        <img :src="bannerImage" alt="">
			</div>
			<div class="flex flex-row-between flex-items-start content-wrap">
				<div class="left-wrap ">
					<router-view/>
				</div>
				<div class="right-wrap">
					<!-- <contractRight :recommend="recommend" :routerZhName="routerZhName" /> -->
					<contractRight />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import contractRight from '@/views/contract/components/contract-right'
export default {
	components: {
		contractRight,
	},
	data() {
		return {
			
		};
	},
	created() {

	},
	mounted() { },
	methods: {
	},
	computed: {
		isContract() {
			return this.$route.path.includes('contractDetail')
		},
    // 新增动态判断图片路径的属性
    bannerImage() {
      // 当路由包含 contractView (即合同履约主页) 时，使用新图
      if (this.$route.path.includes('contractView') || this.$route.path.includes('searchContract')|| this.$route.path.includes('contractDetail')) {
        return require('../../static/images/htly.png');
      }
      // 其他情况（如进入详情页等），保留原图
      return require('../../static/images/creditserver.png');
    }
	},
	watch: {
	},

};
</script>
<style lang='scss' >
	$red: #d01c0b;

	.common-wrap {
		width: 100%;

		.common-inner-wrap {
			width: 1280px;
			margin: 0 auto;
			padding: 20px 0 20px;

			.content-wrap {
				padding-top: 20px;
				.left-wrap {
					width: 775px;
				}
				.right-wrap {
					width: calc(100% - 20px - 775px);
				}
			}
		}
	}
</style>